module.exports = __webpack_public_path__ + "img/ctg-whats.07b45f8b.svg";